import config from "../config";

export const BaseURL = config.API_BASE_URL;
export const loginURL = `${BaseURL}/account/dashboard/login`;
export const logoutURL = `${BaseURL}/account/dashboard/logout`;
export const userInfo = `${BaseURL}/account/dashboard/loggedInInfo`;
export const profileURL = `${BaseURL}/account/dashboard/home`;
export const teamsURL = `${BaseURL}/account/dashboard/teams`;
export const membersURL = `${BaseURL}/account/dashboard/members`;
export const coachesURL = `${BaseURL}/account/dashboard/coaches`;
export const categoriesURL = `${BaseURL}/account/dashboard/categories`;
export const categoriesWithPricesURL = `${BaseURL}/account/dashboard/categories/withPrices`;
export const paymentURL = `${BaseURL}/account/dashboard/payment/credit`;
export const transactionsURL = `${BaseURL}/account/dashboard/payment/transactions`;
export const verifyURL = `${BaseURL}/account/dashboard/verify`;
